"use client";
import { extractUrlAndSessionValues } from "../filters/result-filters";
import { useSearchParams } from "next/navigation";
import { createContext, useContext, useState, ReactNode } from "react";
import { LOCATION_MILES_ARRAY } from "@packages/shared-components/common-utilities/popups/search-filtercomponent/filter-contant-values/filter-constants";
const FilterContext = createContext<any | undefined>(undefined);

export const FilterProvider = ({
  children,
  path,
}: {
  children: ReactNode;
  path?: string;
}) => {
  const searchParams = useSearchParams();
  const [routerEnd, setrouterEnd] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [slug, setSlug] = useState(path || "degree-courses/search");
  const [prepopulateFilter, setPrepopulateFilter] = useState<any>({
    studyMethod: "",
    studyMode: "",
    year: "",
    month: "",
    location: "",
    russellGroup: "",
    locationType: "",
    university: "",
    qualication: "",
    subject: "",
    studyLevel: "",
  });
  const [universityState, setUniversityState] = useState({
    universityKeyword: "",
    sortedUni: [],
    isUniversityDropdownOpen: false,
    isUniversityOpen: false,
    selectUniId: {
      id: "",
      displayHeading: "",
    },
  });

  const [subjectState, setSubjectState] = useState({
    subjectkeyword: "",
    sortedSubjects: [],
    isSujectDropdownOpen: false,
    isSubjectOpen: false,
    selectedSubject: {
      parentSubject: {},
      subjectList: [],
    },
  });

  const [filterState, setFilterState] = useState<any>({
    isFilterOpen: false,
    isFilterLoading: false,
    filterOrder: extractUrlAndSessionValues(searchParams, "", ""),
    selectedFilter: "",
  });

  const [locationState, setLocationState] = useState<any>({
    isdropDownOpen: false,
    mileDisplayName:
      searchParams?.get("distance") === "any"
        ? "Any"
        : searchParams?.get("distance") || "Any",
    selectedMile: searchParams?.get("distance")
      ? searchParams?.get("distance")
      : "any",
    locationMilesArray: LOCATION_MILES_ARRAY,
    locationMilesError: false,
    postCodeValue:
      searchParams?.get("postcode")?.replace("+", " ")?.toUpperCase() || "",
    appliedParentRegion: [],
    appliedChildRegion: [],
  });

  return (
    <FilterContext.Provider
      value={{
        slug,
        routerEnd,
        filterState,
        subjectState,
        locationState,
        universityState,
        selectedLocation,
        prepopulateFilter,
        setSlug,
        setrouterEnd,
        setFilterState,
        setSubjectState,
        setLocationState,
        setUniversityState,
        setSelectedLocation,
        setPrepopulateFilter,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  if (context === undefined) {
    throw new Error("useAppContext must be used within AppProvider");
  }
  return context;
};
